<template>
  <div id="app">
    <Navigation></Navigation>
    <div class="section no-pad-bot no-pad-top" id="index-banner">
      <div>
        <br><br>
        <h1 class="header center">{{$t('main.title')}}</h1>
        <div class="row center">
          <h5 class="header col s12 light">{{$t('main.subtitle')}}</h5>
        </div>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <footer class="page-footer grey darken-3">
      <div class="container">
        <div class="row">
          <div class="col 12">
            <h5 class="white-text">{{$t('main.short.title')}}</h5>
            <p class="grey-text text-lighten-4" v-html="$t('main.short.description')">
            </p>
          </div>
        </div>
      </div>
      <div class="footer-copyright">
        <div class="container center" v-html="$t('main.contact')">
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import Navigation from './components/Navigation'

  export default {
    name: 'App',
    components: {
      'Navigation': Navigation
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue